import {Component, Vue, Watch} from 'vue-property-decorator'
import { UserModule } from '@/store/modules/user'
import {
    gettHeaderByType,
    settHeaderByType,
    getMarketCooperation,
    setMarketCooperationUser,
    marketCooperationExportData,
    delMarketCooperationById,
    getDeparmentList
} from '@/api/common';
import { setMarketCooperationStatusById , getMarketCooperationContrastExport,getMarketCooperationFinanceOrderExport } from '@/api/market'
import { formatDate } from '@/utils/timeFilter'
import { menuBtn } from '@/utils/menu_level2_button'
import { delNullProperty } from '@/utils/index'
import { importMarketCooperation } from '@/api/market'

import {
    lastMonth,
    lastQuarter,
    lastWeek, lastYear,
    thisMonth,
    thisQuarter,
    thisToday,
    thisWeek, thisYear,
    thisYesterday
} from "@/utils/dateTime";
import MoreUsersFilter from "@/components/moreUsersFilter/index.vue";
const sourceList = [
    {label: 'BD自开拓', value: '0'},
    {label: '市场自开拓', value: '1'},
    {label: 'KA战略合作', value: '2'},
    {label: '高校业务部门', value: '3'},
    {label: '咨询平台', value: '4'},
    {label: '咨询自渠道', value: '5'}
]
Vue.filter('filterSource', (val: string) => {
    const item = sourceList.filter(item => item.value === val)[0]
    return item ? item.label : ''
})
@Component({
    filters: {
        reviewStatus: (val) => {
            switch (val) {
                case '0':
                    return '审批中'
                    break;
                case '1':
                    return '已通过'
                    break;
                case '2':
                    return '未通过'
                    break;
                case '3':
                    return '未提交'
                    break;
                case '4':
                    return '已撤回'
                    break;
                default:
                    return '未知状态'
                    break;
            }
        }
    },
    components:{
        MoreUsersFilter
    }
})
export default class CooperationManagement extends Vue {
    // data
    tableData = []
    tableHead: any[] = []
    page = 1
    limit = 20
    total = 0
    tableHeadFilter = {
        name: '',
        marketCooperationName: '',
        directorUserIdList: [],
        source: '',
        types: '',
        commissionType: '',
        createdAt1: '',
        createdAt: '',
        visitNum: '',// 拜访次数 2023-2-15
        financeOrderCount: '',// 累计送生数, 2023-2-15
        departmentIdList: [],// 负责人所属部门id 2023-2-15
        backMoneyType: '',// 回款类型
        isHaveContract: '',// 签署合同
        isHaveOutput: '',
        isHaveApplication: '',
        createdUserIdList: [],
        code:''
    }
    tableHeadPopoverShow = false
    tableCheckedData = []
    dialogShow = false
    receiverUser = '' // 修改后的负责人
    loading = false
    giveStudentLoading=false //导出loading
    cancleReviewShow = false // 撤回审批弹框
    cancleReviewId: number = undefined // 撤回审批的合作伙伴id
    file = null
    exportwShow = false
    exportwShow1 = true
    exportwShow2 = false
    exportwShow3 = false
    fileData = null
    delDialog = false
    delRow = null
    uploadNum = {
        successNum: 0,
        failNum: 0,
        allNum: 0,
        ossUrl: '',
    }
    exportBUttonDisabled = false
    exportHeaderDialogVisible = false
    tableKey = Math.random()
    visitScopen = ''
    visitVal = ''
    financeOrderCount = ''
    financeOrderVal = ''
    deparmentList: any = [] // 部门列表
    checkRangeDepartmentList: Array<number> = [] // 适用范围内选中的部门 id
    accessibleList: any = []
    checkDeparmentInfo: any = [] // 选中的部门信息
    departmentIdList = []
    marketVisitRateShow = false
    timeType = '1'
    timeStr = ''
    timeType1 = '1'
    timeStr1 = ''
    startWeek = '' // 本周开始
    endWeek = '' //本周结束
    startMonth = '' // 本月开始
    endMonth = ''  //本月结束
    startLastWeek = '' //上周开始
    endLastWeek = '' //上周结束
    startLastMonth = '' // 上月开始
    endLastMonth = ''  // 上月结束
    startQuarter = ''  // 本季度开始
    endQuarter = '' // 本季度结束
    startLastQuarter = '' //上季度开始
    endLastQuarter = '' //上季度结束
    startYear = '' // 本年开始
    endYear = '' // 本年结束
    timeStrDate = []
    today = ''
    yesterday = ''
    yesteryearStart = ''
    yesteryearEnd = ''
    timeStrDate1 = []
    disBtn = false
    giveStudentExportShow = false
    timer = null
    // isReadonly = false
    draggableList = []
    draggableListChange = []
    giveStudentloading = false
    marketVisitLoading = false
    contrastTableHeader: any = [
        { filds: 'name', cnFilds: '合作伙伴名称', isShow: true, id: 1 },
        { filds: 'firstCount', cnFilds: 'timeFirst', isShow: true, id: 2 },
        { filds: 'secondCount', cnFilds: 'timeSecond', isShow: true, id: 3 },
    ]
    contrastCheckedKeys: string[] = ['name', 'firstCount', 'secondCount']
    popHeight = 0
    vdaH = 0 //屏幕高度

    // computed
    get arrOrderCount() {
        const financeOrderCount = this.financeOrderCount
        const financeOrderVal = this.financeOrderVal
        return {
            financeOrderCount, financeOrderVal
        }
    }

    get arrvisitScopen(){
        const visitVal = this.visitVal
        const visitScopen = this.visitScopen
        return {
            visitScopen, visitVal
        }
    }


    /* created */
    created() {
        this.gettHeaderByType()
        const h = document.documentElement.clientHeight || document.body.clientHeight;
        this.vdaH = h - 260 ;
        this.popHeight = this.vdaH
        this.getDeparment()
        this.getDateInterval()
    }

    // methods

    async getDeparment() {
        const data: any = await getDeparmentList()
        this.deparmentList = data
    }

    /*拜访统计报表*/
    visitStatisticsData(){
        const win = window.open(window.location.origin + this.$route.matched[0].path + '/VisitStatisticsTable')
        const time = setInterval(() => {
            if (win.closed) {
                this.getMarketCooperation()
                clearInterval(time)
            }
        }, 500)
    }

    // 咨询
    openConsult(row: any) {
        const win = window.open(window.location.origin + this.$route.matched[0].path + '/Consult?id=' + row.id + '&name=' + row.name)
        const time = setInterval(() => {
            if (win.closed) {
                this.getMarketCooperation()
                clearInterval(time)
            }
        }, 500)
    }
    // 查看咨询记录
    openConsultRecord(row: any) {
        const win = window.open(window.location.origin + this.$route.matched[0].path + '/ConsultRecord?id=' + row.id + '&name=' + row.name)
        const time = setInterval(() => {
            if (win.closed) {
                this.getMarketCooperation()
                clearInterval(time)
            }
        }, 500)
    }


    async gettHeaderByType() {
        const data: any = await gettHeaderByType(2)
        this.draggableList = data.headerUserList
        this.tableHead = JSON.parse(JSON.stringify(data.headerUserList))
        this.draggableListChange = JSON.parse(JSON.stringify(data.headerUserList))
        this.getMarketCooperation()
    }
    async getMarketCooperation() {
        this.loading = true

        this.tableHeadFilter.visitNum = this.visitScopen + this.visitVal
        this.tableHeadFilter.financeOrderCount = this.financeOrderCount + this.financeOrderVal
        this.tableHeadFilter.departmentIdList = this.departmentIdList
        const obj = { ...this.tableHeadFilter, page: this.page, limit: this.limit }
        const data: any = await getMarketCooperation(delNullProperty(obj))
        const { allNum, marketCooperationList } = data
        this.total = allNum
        this.tableData = marketCooperationList
        this.tableKey = Math.random()
        this.$nextTick(() => {
            if (this.$refs.multipleTable) {
                (this.$refs.multipleTable as HTMLFormElement).doLayout();
                (this.$refs.multipleTable as HTMLFormElement).bodyWrapper.scrollTop = 0;
            }
        });
        this.loading = false
        // this.isReadonly = false
    }
    changeTable() {
        const newArr = []
        this.draggableListChange.forEach(item => {
            if (item.isShow === true) {
                newArr.push(item)
            }
        })
        if (newArr.length == 1) {
            newArr.forEach(item => {
                item.isDisBtn = true
            })
        } else {
            newArr.forEach(item => {
                item.isDisBtn = false
            })
        }
    }
    async draggableEnd() {
        this.tableHeadPopoverShow = false
        this.draggableList = this.draggableListChange
        const newArr: object = this.draggableList.filter(item =>
            item.isShow === true
        )
        if ((newArr as []).length > 0) {
            await settHeaderByType({types: 2, headerIds: this.draggableList})
            this.$message.success('表头设置成功')
            this.gettHeaderByType()
        } else {
            this.$message.error('至少保留一个表头')
        }
    }

    doCancel(){
        this.draggableListChange = JSON.parse(JSON.stringify( this.draggableList))
        this.tableHeadPopoverShow = false
    }

    changeDate(val: Date[]) {
        if (val === null || val.length === 0) {
            this.tableHeadFilter.createdAt = ''
        }
        const arr: string[] = []
        val.forEach((item: Date) => {
            arr.push(formatDate('yyyy-MM-dd', new Date(item)))
        })
        this.tableHeadFilter.createdAt = arr.join('/')

        if (this.timer !== null) clearTimeout(this.timer)
        this.timer = setTimeout(() => {
            if (this.visitScopen && !this.visitVal) {
                this.$message.error('请输入拜访次数');
                return
            }
            if (this.visitVal && !this.visitScopen) {
                this.$message.error('请选择运算符');
                return
            }
            if (this.financeOrderCount && !this.financeOrderVal) {
                this.$message.error('请输入送生数');
                return
            }
            if (this.financeOrderVal && !this.financeOrderCount) {
                this.$message.error('请选择运算符');
                return
            }
            this.page = 1
            this.getMarketCooperation();
        }, 1000)
    }

    pageChange(page: number) {
        if (this.timer !== null) clearTimeout(this.timer)
        this.timer = setTimeout(() => {
            if (this.visitScopen && !this.visitVal) {
                this.$message.error('请输入拜访次数');
                return
            }
            if (this.visitVal && !this.visitScopen) {
                this.$message.error('请选择运算符');
                return
            }
            if (this.financeOrderCount && !this.financeOrderVal) {
                this.$message.error('请输入送生数');
                return
            }
            if (this.financeOrderVal && !this.financeOrderCount) {
                this.$message.error('请选择运算符');
                return
            }
            this.page = page
            this.getMarketCooperation();
        }, 1000)

    }
    pageSizeChange(limit: number) {
        this.limit = limit
        this.getMarketCooperation();
    }
    handleSelectionChange(row: any) {
        this.tableCheckedData = row
    }
    async dialogConfirm() {
        if (!this.receiverUser) {
            this.$message.error('请选择负责人')
            return
        }
        const idList = this.tableCheckedData.map((item: any) => (item.id))
        await setMarketCooperationUser({
            idList,
            userId: this.receiverUser
        })
        this.$message.success('修改负责人成功')
        this.dialogShow = false
        this.getMarketCooperation();
        (this.$refs['multipleTable'] as HTMLFormElement).clearSelection();
    }
    openDtatisticsData() {
        window.open(window.location.origin + this.$route.matched[0].path + '/CooperationStatisticsData')
    }
    openGiveStudent(row) {
        if (menuBtn(31)) {
            window.open(window.location.origin + this.$route.matched[0].path + `/GiveStudent?id=${row.id}&name=${row.name}&type=${row.types === '0' ? '个人代理' : '机构'}&userName=${row.directorUserRealName}&source=${row.source}`, '_blank')
        }
    }
    openNewVisit(row: any) {
        const win = window.open(window.location.origin + this.$route.matched[0].path + '/NewVisit?id=' + row.id + '&name=' + row.name)
        const time = setInterval(() => {
            if (win.closed) {
                this.getMarketCooperation()
                clearInterval(time)
            }
        }, 500)
    }
    openVisitRecord(row: any) {
        window.open(window.location.origin + this.$route.matched[0].path + '/VisitRecord?id=' + row.id + '&name=' + row.name)
    }
    openNewPartner() {
        const win = window.open(window.location.origin + this.$route.matched[0].path + '/newPartner', '_blank')
        const timer = setInterval(() => {
            if (win.closed) {
                this.getMarketCooperation()
                clearInterval(timer)
            }
        }, 500)
    }

    // 跳转合作伙伴详情页
    clickRow(row: any, cloumn: any) {
        if (cloumn.label !== '累计送生数' && cloumn.label !== '操作' && menuBtn(26)) {
            const win = window.open(window.location.origin + this.$route.matched[0].path + '/seePartner?id=' + row.id + '&type=0' + '&status=' + row.status, '_blank')
            const timer = setInterval(() => {
                if (win.closed) {
                    this.getMarketCooperation()
                    clearInterval(timer)
                }
            }, 500)
        }
    }

    // 新增的查看
    goToSee(row) {
        const win = window.open(window.location.origin + this.$route.matched[0].path + '/seePartner?id=' + row.id + '&type=0' + '&status=' + row.status, '_blank')
        const timer = setInterval(() => {
            if (win.closed) {
                this.getMarketCooperation()
                clearInterval(timer)
            }
        }, 500)
    }

    // 跳转合作伙伴编辑页
    handleEdit(row) {
        const win = window.open(window.location.origin + this.$route.matched[0].path + '/newPartner?id=' + row.id + '&type=0', '_blank')
        const timer = setInterval(() => {
            if (win.closed) {
                this.getMarketCooperation()
                clearInterval(timer)
            }
        }, 500)
    }
    goTodetail(row) {
        const win = window.open(window.location.origin + this.$route.matched[0].path + '/newPartner?id=' + row.id + '&type=1', '_blank')
        const timer = setInterval(() => {
            if (win.closed) {
                this.getMarketCooperation()
                clearInterval(timer)
            }
        }, 500)
    }

    async exportExcel(keys: string = '') {
        this.exportBUttonDisabled = true
        this.tableHeadFilter.visitNum = this.visitScopen + this.visitVal
        this.tableHeadFilter.financeOrderCount = this.financeOrderCount + this.financeOrderVal
        this.tableHeadFilter.departmentIdList = this.departmentIdList
        marketCooperationExportData(delNullProperty({ ...this.tableHeadFilter, keys })).then(() => {
            this.exportBUttonDisabled = false
            this.$message.success('数据已转入后台导出, 请前往下载列表查看')
        }).catch(() => {
            this.exportBUttonDisabled = false
        })
    }

    // 撤回审批
    cancleReview(row) {
        this.cancleReviewId = row.id
        this.cancleReviewShow = true
    }

    async cancleReviewDialogConfirm() {
        await setMarketCooperationStatusById(this.cancleReviewId)
        this.$message.success('审批撤回成功')
        this.getMarketCooperation()
        this.cancleReviewShow = false
    }
    closeExport() {
        const upload: any = this.$refs.upload
        upload.clearFiles()
        this.exportwShow = false
        this.file = null
    }
    async sureExport() {
        this.exportwShow1 = false
        this.exportwShow2 = true
        const formData = new FormData()
        formData.append('file', this.file.raw)
        // const { allNum, failNum, successNum, ossUrl } = await importMarketCooperation(formData) as unknown as
        // this.uploadNum = { allNum, failNum, successNum, ossUrl }
        importMarketCooperation(formData).then((res) => {
            const { allNum, failNum, successNum, ossUrl } = res as unknown as { allNum: number; failNum: number; successNum: number; ossUrl: string }
            this.uploadNum = { allNum, failNum, successNum, ossUrl }
            // 成功后就展示成功提示
            this.exportwShow3 = true
            this.exportwShow2 = false
            this.file = null
            this.fileData = {}
        }).catch(err => {

            this.exportwShow3 = false
            this.exportwShow2 = false
            this.exportwShow1 = true
        })
    }
    closeExportDialog() {
        this.exportwShow3 = false;
        this.exportwShow = false
        this.file = null
        this.getMarketCooperation()
    }
    handleFileChange(file) {
        const upload: any = this.$refs.upload
        upload.clearFiles()
        this.file = file
    }
    downloadError() {
        const a: any = document.createElement('a')
        a.href = this.uploadNum.ossUrl //  URL对象
        a.click() // 模拟点击
    }
    downloadTemplate() {
        const url: any = 'https://gecacademy.oss-cn-beijing.aliyuncs.com/crm/excel/excel%E6%A8%A1%E6%9D%BF/%E5%90%88%E4%BD%9C%E4%BC%99%E4%BC%B4%E5%AF%BC%E5%85%A5%E8%A1%A8%E6%A0%BC.xlsx'
        const a: any = document.createElement('a')
        a.href = url //  URL对象
        a.click() // 模拟点击
    }
    deleteButton(row) {
        this.delDialog = true
        this.delRow = row
    }
    async confirmDel() {
        await delMarketCooperationById({id: this.delRow.id})
        this.$message.success('操作成功')
        this.delRow = null
        this.delDialog = false
        this.getMarketCooperation()
    }


    chooseDepartment(checkedKeys){
        // console.log('checkedKeys',checkedKeys)

        const tree = this.$refs.tree as HTMLFormElement
        const arr = []
        tree.forEach(item => {
            arr.push(item.getCheckedKeys())
        })

        // console.log('arr',arr)
        function flatter(arr) {
            //此代码的意思是接受一个数组作为参数
            const newArr = [];  // 这个空数组用于处理扁平化之后的数组元素
            function fn(date) {  //如果date是一个数组就需要对date经行遍历
                for (let i = 0; i < date.length; i++) {
                    const tem = date[i];  // 使用tem储存每一个数组的元素
                    if (Array.isArray(tem)) { //表示如果tem是一个数组，则执行下面的函数
                        fn(tem)  //调用fn函数，并传入一个实参
                    } else {
                        newArr.push(tem);//此代码的意思是，如果不是一个数组就把每个元素push到newArr 这个数组中
                    }
                }
            }

            fn(arr) //表示调用上面的fn函数，并且传入一个实参arr
            return newArr //表示返回这个结果，讲这个结果返回给这个函数的调用者
        }

        const p = flatter(arr) //表示返回这个结果，并且赋值给p

        this.departmentIdList = p
    }

    treeChange(item: any, itembol: boolean) {
        // console.log('item',item)

    }

    // 导出
    async exportExcelRate() {
        this.disBtn = true
        this.marketVisitLoading = true
        const obj = {firstTimeStr: this.timeStr, secondTimeStr: this.timeStr1, keys: this.contrastCheckedKeys.join(',')}
        await getMarketCooperationContrastExport(delNullProperty(obj)).then(() => {
            this.disBtn = false
            this.marketVisitRateShow = false
            this.marketVisitLoading = false
            this.$message.success('数据已转入后台导出, 请前往下载列表查看')
        }).catch(() => {
            this.disBtn = false
            this.marketVisitRateShow = false
            this.marketVisitLoading = false
        })
    }
    /*合作伙伴送生数对比导出*/
    async giveStudentExport() {
        this.disBtn = true
        this.giveStudentloading = true
        const obj = {firstTimeStr: this.timeStr, secondTimeStr: this.timeStr1, keys: this.contrastCheckedKeys.join(',')}
        await getMarketCooperationFinanceOrderExport(delNullProperty(obj)).then(() => {
            this.disBtn = false
            this.giveStudentExportShow = false
            this.giveStudentloading = false
            this.$message.success('数据已转入后台导出, 请前往下载列表查看')
        }).catch(() => {
            this.disBtn = false
            this.giveStudentExportShow = false
            this.giveStudentloading = false
        })
    }

    // 选择区间
    changeDateType(val) {
        if (val === '2') {  //    本周
            this.timeStr = this.startWeek + '&' + this.endWeek
            this.timeStrDate = [this.startWeek, this.endWeek]
        } else if (val === '3') { // 本月
            this.timeStr = this.startMonth + '&' + this.endMonth
            this.timeStrDate = [this.startMonth, this.endMonth]
        } else if (val === '4') { // 本季度
            this.timeStr = this.startQuarter + '&' + this.endQuarter
            this.timeStrDate = [this.startQuarter, this.endQuarter]
        } else if (val === '5') { // 本年
            this.timeStr = this.startYear + '&' + this.endYear
            this.timeStrDate = [this.startYear, this.endYear]
        } else if (val === '6') { // 上周
            this.timeStr = this.startLastWeek + '&' + this.endLastWeek
            this.timeStrDate = [this.startLastWeek, this.endLastWeek]
        } else if (val === '7') { // 上月
            this.timeStr = this.startLastMonth + '&' + this.endLastMonth
            this.timeStrDate = [this.startLastMonth, this.endLastMonth]
        } else if (val === '8') { // 上季度
            this.timeStr = this.startLastQuarter + '&' + this.endLastQuarter
            this.timeStrDate = [this.startLastQuarter, this.endLastQuarter]
        } else if (val === '9') { // 去年
            this.timeStr = this.yesteryearStart + '&' + this.yesteryearEnd
            this.timeStrDate = [this.yesteryearStart, this.yesteryearEnd]
        } else if (val === '0') { // 昨天
            this.timeStr = this.yesterday + '&' + this.yesterday
            this.timeStrDate = [this.yesterday, this.yesterday]
        } else if (val === '1') { // 今天
            this.timeStr = this.today + '&' + this.today
            this.timeStrDate = [this.today, this.today]
        } else {
            this.timeStr = ''
            this.timeStrDate = []
        }

    }

    handleChangeData(val) {
        const week = [this.startWeek, this.endWeek]
        const month = [this.startMonth, this.endMonth]
        const year = [this.startYear, this.endYear]
        const quarter = [this.startQuarter, this.endQuarter]
        const lastWeek = [this.startLastWeek, this.endLastWeek]
        const lastMonth = [this.startLastMonth, this.endLastMonth]
        const lastQuarter = [this.startLastQuarter, this.endLastQuarter]
        const lastyear = [this.yesteryearStart, this.yesteryearEnd]
        const yesterday = [this.yesterday, this.yesterday]
        const today = [this.today, this.today]
        if (week[0].indexOf(val[0]) !== -1 && week[1].indexOf(val[1]) !== -1) {
            this.timeType = '2'
        } else if (month[0].indexOf(val[0]) !== -1 && month[1].indexOf(val[1]) !== -1) {
            this.timeType = '3'
        } else if (quarter[0].indexOf(val[0]) !== -1 && quarter[1].indexOf(val[1]) !== -1) {
            this.timeType = '4'
        } else if (year[0].indexOf(val[0]) !== -1 && year[1].indexOf(val[1]) !== -1) {
            this.timeType = '5'
        } else if (lastWeek[0].indexOf(val[0]) !== -1 && lastWeek[1].indexOf(val[1]) !== -1) {
            this.timeType = '6'
        } else if (lastMonth[0].indexOf(val[0]) !== -1 && lastMonth[1].indexOf(val[1]) !== -1) {
            this.timeType = '7'
        } else if (lastQuarter[0].indexOf(val[0]) !== -1 && lastQuarter[1].indexOf(val[1]) !== -1) {
            this.timeType = '8'
        } else if (lastyear[0].indexOf(val[0]) !== -1 && lastyear[1].indexOf(val[1]) !== -1) {
            this.timeType = '9'
        } else if (yesterday[0].indexOf(val[0]) !== -1 && yesterday[1].indexOf(val[1]) !== -1) {
            this.timeType = '0'
        } else if (today[0].indexOf(val[0]) !== -1 && today[1].indexOf(val[1]) !== -1) {
            this.timeType = '1'
        } else {
            this.timeType = '自定义时间'
        }
        this.timeStr = val[0] + '&' + val[1]
        // this.getMarketChannelName()
    }
    // 初始化获取日期区间
    getDateInterval() {
        // 获取今天
        this.today = thisToday();

        // 获取昨天
        this.yesterday = thisYesterday();

        // 本周
        this.startWeek = thisWeek()[0]//周一日期
        this.endWeek = thisWeek()[1];//周日日期

        //上周
        this.startLastWeek = lastWeek()[0]; //周一日期
        this.endLastWeek = lastWeek()[1]; //周日日期

        // 本月
        this.startMonth = thisMonth()[0]
        this.endMonth = thisMonth()[1]

        // 上月
        this.startLastMonth = lastMonth()[0];
        this.endLastMonth = lastMonth()[1];

        // 本季度
        this.startQuarter = thisQuarter()[0];
        this.endQuarter = thisQuarter()[1];

        // 上季度
        this.startLastQuarter = lastQuarter()[0];
        this.endLastQuarter = lastQuarter()[1];

        //本年
        this.startYear = thisYear()[0];
        this.endYear = thisYear()[1];

        // 获取去年
        this.yesteryearStart = lastYear()[0];
        this.yesteryearEnd = lastYear()[1];

        if (this.timeType == '1') {
            this.timeStr = this.today + '&' + this.today
            this.timeStrDate = [this.today, this.today]
            // this.getData()
        }
        if (this.timeType1 == '1') {
            this.timeStr1 = this.today + '&' + this.today
            this.timeStrDate1 = [this.today, this.today]
            // this.getData()
        }

    }
    // 选择区间
    changeDateType1(val) {
        if (val === '2') {  //    本周
            this.timeStr1 = this.startWeek + '&' + this.endWeek
            this.timeStrDate1 = [this.startWeek, this.endWeek]
        } else if (val === '3') { // 本月
            this.timeStr1 = this.startMonth + '&' + this.endMonth
            this.timeStrDate1 = [this.startMonth, this.endMonth]
        } else if (val === '4') { // 本季度
            this.timeStr1 = this.startQuarter + '&' + this.endQuarter
            this.timeStrDate1 = [this.startQuarter, this.endQuarter]
        } else if (val === '5') { // 本年
            this.timeStr1 = this.startYear + '&' + this.endYear
            this.timeStrDate1 = [this.startYear, this.endYear]
        } else if (val === '6') { // 上周
            this.timeStr1 = this.startLastWeek + '&' + this.endLastWeek
            this.timeStrDate1 = [this.startLastWeek, this.endLastWeek]
        } else if (val === '7') { // 上月
            this.timeStr1 = this.startLastMonth + '&' + this.endLastMonth
            this.timeStrDate1 = [this.startLastMonth, this.endLastMonth]
        } else if (val === '8') { // 上季度
            this.timeStr1 = this.startLastQuarter + '&' + this.endLastQuarter
            this.timeStrDate1 = [this.startLastQuarter, this.endLastQuarter]
        } else if (val === '9') { // 去年
            this.timeStr1 = this.yesteryearStart + '&' + this.yesteryearEnd
            this.timeStrDate1 = [this.yesteryearStart, this.yesteryearEnd]
        } else if (val === '0') { // 昨天
            this.timeStr1 = this.yesterday + '&' + this.yesterday
            this.timeStrDate1 = [this.yesterday, this.yesterday]
        } else if (val === '1') { // 今天
            this.timeStr1 = this.today + '&' + this.today
            this.timeStrDate1 = [this.today, this.today]
        } else {
            this.timeStr1 = ''
            this.timeStrDate1 = []
        }

    }
    handleChangeData1(val) {
        const week = [this.startWeek, this.endWeek]
        const month = [this.startMonth, this.endMonth]
        const year = [this.startYear, this.endYear]
        const quarter = [this.startQuarter, this.endQuarter]
        const lastWeek = [this.startLastWeek, this.endLastWeek]
        const lastMonth = [this.startLastMonth, this.endLastMonth]
        const lastQuarter = [this.startLastQuarter, this.endLastQuarter]
        const lastyear = [this.yesteryearStart, this.yesteryearEnd]
        const yesterday = [this.yesterday, this.yesterday]
        const today = [this.today, this.today]
        if (week[0].indexOf(val[0]) !== -1 && week[1].indexOf(val[1]) !== -1) {
            this.timeType1 = '2'
        } else if (month[0].indexOf(val[0]) !== -1 && month[1].indexOf(val[1]) !== -1) {
            this.timeType1 = '3'
        } else if (quarter[0].indexOf(val[0]) !== -1 && quarter[1].indexOf(val[1]) !== -1) {
            this.timeType1 = '4'
        } else if (year[0].indexOf(val[0]) !== -1 && year[1].indexOf(val[1]) !== -1) {
            this.timeType1 = '5'
        } else if (lastWeek[0].indexOf(val[0]) !== -1 && lastWeek[1].indexOf(val[1]) !== -1) {
            this.timeType1 = '6'
        } else if (lastMonth[0].indexOf(val[0]) !== -1 && lastMonth[1].indexOf(val[1]) !== -1) {
            this.timeType1 = '7'
        } else if (lastQuarter[0].indexOf(val[0]) !== -1 && lastQuarter[1].indexOf(val[1]) !== -1) {
            this.timeType1 = '8'
        } else if (lastyear[0].indexOf(val[0]) !== -1 && lastyear[1].indexOf(val[1]) !== -1) {
            this.timeType1 = '9'
        } else if (yesterday[0].indexOf(val[0]) !== -1 && yesterday[1].indexOf(val[1]) !== -1) {
            this.timeType1 = '0'
        } else if (today[0].indexOf(val[0]) !== -1 && today[1].indexOf(val[1]) !== -1) {
            this.timeType1 = '1'
        } else {
            this.timeType1 = '自定义时间'
        }
        this.timeStr1 = val[0] + '&' + val[1]
        // this.getMarketChannelName()
    }

    /*
    按钮权限验证
    */
    handleBtn(id: number) {
        return menuBtn(id)
    }
    handleCopy(id) {
        const origin = location.hostname//当前访问域名
        let customLink = ''
        if (process.env.NODE_ENV === 'development') {
            customLink = 'http://www-testserver.gzistudycenter.cn/registration?channelId=' + id
        } else {
            if (origin.indexOf('-testserver') > -1) {
                customLink = 'http://www-testserver.gzistudycenter.cn/registration?channelId=' + id
            } else {
                customLink = 'http://www.gzistudycenter.cn/registration?channelId=' + id
            }
        }
        // 创建临时输入框
        const textarea = document.createElement('textarea')
        textarea.value = customLink
        textarea.style.position = 'fixed'
        textarea.style.opacity = '0'
        document.body.appendChild(textarea)
        // 选择并复制
        textarea.select()
        const successful = document.execCommand('copy')
        // 移除临时输入框
        document.body.removeChild(textarea)
        if (successful) {
            this.$message.success('链接已复制到剪贴板')
        } else {
            this.$message.error('复制失败，请手动复制')
        }
    }
    changeDirectorUserIdList(e){
        this.tableHeadFilter.directorUserIdList = e.id
        if (this.timer !== null) clearTimeout(this.timer)
        this.timer = setTimeout(() => {
            if (this.visitScopen && !this.visitVal) {
                this.$message.error('请输入拜访次数');
                return
            }
            if (this.visitVal && !this.visitScopen) {
                this.$message.error('请选择运算符');
                return
            }
            if (this.financeOrderCount && !this.financeOrderVal) {
                this.$message.error('请输入送生数');
                return
            }
            if (this.financeOrderVal && !this.financeOrderCount) {
                this.$message.error('请选择运算符');
                return
            }
            this.page = 1
            this.getMarketCooperation();
        }, 1000)
    }

    changeCreatedUserIdList(e) {
        this.tableHeadFilter.createdUserIdList = e.id
        this.timer = setTimeout(() => {
            if (this.visitScopen && !this.visitVal) {
                this.$message.error('请输入拜访次数');
                return
            }
            if (this.visitVal && !this.visitScopen) {
                this.$message.error('请选择运算符');
                return
            }
            if (this.financeOrderCount && !this.financeOrderVal) {
                this.$message.error('请输入送生数');
                return
            }
            if (this.financeOrderVal && !this.financeOrderCount) {
                this.$message.error('请选择运算符');
                return
            }
            this.page = 1
            this.getMarketCooperation();
        }, 1000)
    }
    changeReceiverUser(e){
        this.receiverUser = e.id
        if (this.timer !== null) clearTimeout(this.timer)
        this.timer = setTimeout(() => {
            if (this.visitScopen && !this.visitVal) {
                this.$message.error('请输入拜访次数');
                return
            }
            if (this.visitVal && !this.visitScopen) {
                this.$message.error('请选择运算符');
                return
            }
            if (this.financeOrderCount && !this.financeOrderVal) {
                this.$message.error('请输入送生数');
                return
            }
            if (this.financeOrderVal && !this.financeOrderCount) {
                this.$message.error('请选择运算符');
                return
            }
            // this.page = 1
            // this.getMarketCooperation();
        }, 1000)
    }



    @Watch('arrOrderCount')
    handelArrOrderCount(nVal, oval) {
        if ((nVal.financeOrderCount && nVal.financeOrderVal)||(!nVal.financeOrderCount && !nVal.financeOrderVal) ) {
            this.pageChange(1)
        }
    }

    @Watch('arrvisitScopen')
    handelarrvisitScopen(nVal, oval) {
        if ((nVal.visitVal && nVal.visitScopen) ||(!nVal.visitVal && !nVal.visitScopen) ){
            this.pageChange(1)
        }
    }

}
